module.exports = __webpack_public_path__ + "img/cashi.b6701e1c.svg";